<template>
    <div class="container-side" v-if="$route.path  !== '/auth'">
        <div class="logo-side"></div>
        <div v-for="(data, index) in topMenu" :key="`sideMenu${index}`">

            <div class="toggle-menu" @click="toggleMenu(index, 'openedTopMenu')"
                 :class="{ 'open': returnOpen(data.path) }">
                <div class="text-top-menu">{{ data.meta.title }}</div>
            </div>

            <div class="wrap-sub-menu" :class="{ 'open': openedTopMenu.includes(index) }">
                <div>
                    <div v-for="(sec, secIndex) in returnChild(data.children)" :key="`secMenu${secIndex}`">
                        <div v-if="'children' in sec && returnChild(sec.children).length > 0">
                            <div class="toggle-menu sec" @click="toggleMenu(`${index}${secIndex}`, 'opendSecMenu')"
                                 :class="{ 'open': opendSecMenu.includes(`${index}${secIndex}`) }">
                                <div class="text-top-menu">{{ sec.meta.title }}</div>
                            </div>


                            <div class="wrap-sub-menu"
                                 :class="{ 'open': opendSecMenu.includes(`${index}${secIndex}`) }">
                                <div>
                                    <div v-for="(thi, thiIndex) in returnChild(sec.children)"
                                         :key="`thiMenu${thiIndex}`">


                                        <div v-if="'children' in thi && returnChild(thi.children).length > 0">
                                            <div class="toggle-menu thi"
                                                 @click="toggleMenu(`${index}${secIndex}${thiIndex}`, 'opendThiMenu')"
                                                 :class="{ 'open': opendThiMenu.includes(`${index}${secIndex}${thiIndex}`) }">
                                                <div class="text-top-menu">{{ thi.meta.title }}</div>
                                            </div>


                                            <div class="wrap-sub-menu"
                                                 :class="{ 'open': opendThiMenu.includes(`${index}${secIndex}${thiIndex}`) }">
                                                <div>
                                                    <div v-for="(fou, fouIndex) in returnChild(thi.children)"
                                                         :key="`fouMenu${fouIndex}`">
                                                        <div class="btn-sub-menu fou"
                                                             @click="moveFouPage(data, sec, thi, fou)"
                                                             :class="{ 'active': activeFou(data, sec, thi, fou) }">
                                                            <button class="text-sub-menu">{{ fou.meta.title }}</button>
                                                        </div>
                                                    </div>
                                                </div>
                                            </div>
                                        </div>

                                        <div v-else class="btn-sub-menu thi" @click="moveThiPage(data, sec, thi)"
                                             :class="{ 'active': activeThi(data, sec, thi) }">
                                            <button class="text-sub-menu">{{ thi.meta.title }}</button>
                                        </div>
                                    </div>
                                </div>
                            </div>
                        </div>
                        <div class="btn-sub-menu" v-else @click="moveSecPage(data, sec)"
                             :class="{ 'active': activeSec(data, sec) }">
                            <button class="text-sub-menu">{{ sec.meta.title }}</button>
                        </div>
                    </div>
                </div>
            </div>
        </div>
    </div>
</template>

<script>
import util from "@/mixins/util";
import alertMixins from "@/mixins/alertMixins";
import {checkAccessPage} from "@/service/adminAccessPage";
import {getTokenObj} from "@/mixins/Auth";

export default {
    name: "SideMenu",
    mixins: [alertMixins],
    components: {},
    props: {},
    data() {
        return {
            openedTopMenu: [],
            opendSecMenu: [],
            opendThiMenu: [],
            opendFouMenu: [],
            topMenu: [],
        };
    },
    created() {
        this.setMenu();
    },
    mounted() {
    },
    beforeUnmount() {
    },
    unmounted() {
    },
    computed: {},
    methods: {
        returnOpen(data) {
            return this.$route.path.includes(data + '/');
        },
        setMenu() {
            this.topMenu = this.$router.options.routes.filter(
                (data) => {
                    let name = ''
                    return data.meta.sideMenu === true && checkAccessPage(data.meta.accessIdx, false).status
                }
            );
        },

        toggleMenu(index, type) {
            var foundIndex = this[type].findIndex(innerIdx => innerIdx == index)
            if (foundIndex >= 0) {
                this[type].splice(foundIndex, 1);
            } else {
                this[type].push(index);
            }
        },

        activeSec(data, sec) {
            let path = this.$route.path;
            if (path === data.path + '/' + sec.path) {
                return true;
            }else {
                const segments = path.split("/").filter(Boolean);
                const firstTwo = segments.slice(0, 2).join("/");
                const result = "/" + firstTwo;
                if(data.path + '/' + sec.path === '/member/partner/sleep' && path.indexOf('/member/partner/sleep') > -1 ) return true;
                if( path.indexOf('/member/partner/sleep') > -1 && data.path + '/' + sec.path === '/member/partner') return false;
                if(result === data.path + '/' + sec.path){
                    return true;
                }
            }
        },
        activeThi(data, sec, thi) {
            let path = this.$route.path;
            if (path === data.path + '/' + sec.path + '/' + thi.path) {
                return true;
            }
        },
        activeFou(data, sec, thi, fou) {
            let path = this.$route.path;
            if (path === data.path + '/' + sec.path + '/' + thi.path + '/' + fou.path) {
                return true;
            }
        },
        moveSecPage(data, sec) {
            let route = data.path + "/" + sec.path;
            if (sec.meta.forbidden) {
                this.errorAlert('추후 업데이트예정입니다.');
                return
            }

            this.$router.push(route);
        },
        moveThiPage(data, sec, thi) {
            let route = data.path + "/" + sec.path + "/" + thi.path;
            if (thi.meta.forbidden) {
                this.errorAlert('추후 업데이트예정입니다.');
                return
            }
            this.$router.push(route);
        },
        moveFouPage(data, sec, thi, fou) {
            let route = data.path + "/" + sec.path + "/" + thi.path + '/' + fou.path;
            if (fou.meta.forbidden) {
                this.errorAlert('추후 업데이트예정입니다.');
                return
            }
            this.$router.push(route);
        },
        returnChild(data) {
            if (!util.isEmpty(data)) {
                const tokenObj = getTokenObj();
                const g_idx = tokenObj.g_idx;

                return data.filter(item => {
                    const meta = item.meta || {};

                    // isSuperOnly가 true인 경우엔 g_idx === 3만 허용
                    if (meta.isSuperOnly === true) {
                        return g_idx === 3;
                    }

                    // 나머지는 원래 조건 적용
                    return meta.sideMenu === true && checkAccessPage(meta.accessIdx, false).status;
                });
            }
        }

    },
    watch: {},
};
</script>

<style lang="scss"></style>
